var map = {
	"./template.bet575": 1085,
	"./template.bet575.tsx": 1085,
	"./template.bet777": 1086,
	"./template.bet777.tsx": 1086,
	"./template.betblast": 2106,
	"./template.betblast.tsx": 2106,
	"./template.betgalaxy": 1087,
	"./template.betgalaxy.tsx": 1087,
	"./template.betprofessor": 2107,
	"./template.betprofessor.tsx": 2107,
	"./template.betroyale": 2108,
	"./template.betroyale.tsx": 2108,
	"./template.betstride": 1088,
	"./template.betstride.tsx": 1088,
	"./template.buffalobet": 2109,
	"./template.buffalobet.tsx": 2109,
	"./template.chromabet": 1089,
	"./template.chromabet.tsx": 1089,
	"./template.default": 656,
	"./template.default.tsx": 656,
	"./template.fiestabet": 2110,
	"./template.fiestabet.tsx": 2110,
	"./template.forsport": 1090,
	"./template.forsport.tsx": 1090,
	"./template.gigabet": 2111,
	"./template.gigabet.tsx": 2111,
	"./template.goldenbet888": 2007,
	"./template.goldenbet888.tsx": 2007,
	"./template.goldenrush": 2112,
	"./template.goldenrush.tsx": 2112,
	"./template.hyperbet": 1091,
	"./template.hyperbet.tsx": 1091,
	"./template.juicybet": 2113,
	"./template.juicybet.tsx": 2113,
	"./template.junglebet": 2114,
	"./template.junglebet.tsx": 2114,
	"./template.magnumbet": 1092,
	"./template.magnumbet.tsx": 1092,
	"./template.oldgill": 1093,
	"./template.oldgill.tsx": 1093,
	"./template.puntcity": 1094,
	"./template.puntcity.tsx": 1094,
	"./template.puntgenie": 1095,
	"./template.puntgenie.tsx": 1095,
	"./template.pyramidbet": 1096,
	"./template.pyramidbet.tsx": 1096,
	"./template.questbet": 1097,
	"./template.questbet.tsx": 1097,
	"./template.slambet": 2115,
	"./template.slambet.tsx": 2115,
	"./template.sterlingparker": 2116,
	"./template.sterlingparker.tsx": 2116,
	"./template.sugarcastle": 1098,
	"./template.sugarcastle.tsx": 1098,
	"./template.templebet": 2117,
	"./template.templebet.tsx": 2117,
	"./template.titanbet": 2118,
	"./template.titanbet.tsx": 2118,
	"./template.ts": 88,
	"./template.vikingbet": 1099,
	"./template.vikingbet.tsx": 1099,
	"./template.volcanobet": 1100,
	"./template.volcanobet.tsx": 1100,
	"./template.wellbet": 2119,
	"./template.wellbet.tsx": 2119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2417;